import { TextFieldProps } from '@mui/material'
import TextField from '@mui/material/TextField'
import * as React from 'react'
import { NumericFormat, NumericFormatProps } from 'react-number-format'

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void
  name: string
  unitType?: string
}

const NumericFormatAmount = React.forwardRef<NumericFormatProps, CustomProps>(
  function NumericFormatCustom(props, ref) {
    const { onChange, ...other } = props

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={values => {
          onChange({
            target: {
              name: props.name,
              value: values.value
            }
          })
        }}
        style={{ borderRadius: 0 }}
        thousandSeparator
        valueIsNumericString
        prefix='$'
      />
    )
  }
)

const NumericFormatWeight = React.forwardRef<NumericFormatProps, CustomProps>(
  function NumericFormatCustom(props, ref) {
    const { onChange, ...other } = props

    return (
      <NumericFormat
        {...other}
        onChange={undefined}
        getInputRef={ref}
        onValueChange={values => {
          onChange({
            target: {
              name: props.name,
              value: values.value
            }
          })
        }}
        max={2}
        style={{ borderRadius: 0 }}
        thousandSeparator
        valueIsNumericString
        allowNegative={false}
        decimalScale={3}
        suffix=' g'
      />
    )
  }
)

type FormattedInputProps = TextFieldProps & { unitType?: string }

export default function FormattedInput(props: FormattedInputProps) {
  const { sx, unitType = 'mg', ...rest } = props
  return (
    <TextField
      {...rest}
      InputProps={{
        inputComponent: (rest?.name === 'amount'
          ? NumericFormatAmount
          : // eslint-disable-next-line @typescript-eslint/no-explicit-any
            NumericFormatWeight) as any,
        inputProps: { unitType }
      }}
      sx={{
        border: 'none',
        '& fieldset': { display: 'none' },
        '& input': {
          p: 0,
          borderRadius: 0,
          color: 'primary.main',
          bgcolor: 'transparent',
          textAlign: 'right'
        },
        ...sx
      }}
      variant='outlined'
    />
  )
}
